// extracted by mini-css-extract-plugin
module.exports = {"blackSide":"Main_blackSide__1msmv"};